import { Outlet } from 'react-router';
import { BottomNav } from './bottom-nav';
import { TopNav } from './top-nav';
import { OfflineBanner } from './offline-banner';
import { useAuth } from './auth-context';
import { ErrorBoundary } from './error-boundary';
import { useIdleLock } from '@/hooks/useIdleLock';
import { useNotificationToast } from '@/hooks/useNotificationToast';
import { LockScreen } from '../screens/lock-screen';

export function Layout() {
  const { authState } = useAuth();
  useIdleLock();
  useNotificationToast();

  if (authState === 'locked' || authState === 'signed-out' || authState === 'forgot-password') {
    return <LockScreen />;
  }

  return (
    <div className="h-screen flex flex-col" style={{ backgroundColor: 'var(--cream)' }}>
      <TopNav />
      <OfflineBanner />
      <div className="flex-1 pt-16 overflow-hidden">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
      <BottomNav />
    </div>
  );
}
